import React from "react";
import {
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const PoolMemberships = ({ refreshProfiles }) => {
  const [pools, setPools] = React.useState([]);
  const [confirming, setConfirming] = React.useState(null);
  const [leaving, setLeaving] = React.useState(false);

  React.useEffect(() => {
    getPools();
  }, []);

  const getPools = async () => {
    const result = await request("pool/mine");
    if (result.success) {
      setPools(result.pools || []);
    }
  };

  const handleLeave = async () => {
    setLeaving(true);
    const result = await request("pool/leave", "post", {
      poolId: confirming._id,
    });
    setLeaving(false);
    if (!result.success) {
      toast.error(result.error);
      return;
    }
    setPools((prev) => prev.filter((p) => p._id !== confirming._id));
    setConfirming(null);
    toast.success("You have left the list");
    if (refreshProfiles) refreshProfiles();
  };

  if (!pools.length) return null;

  return (
    <Grid item>
      <Paper height={3}>
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          subheader={
            <ListSubheader component="div" id="pool-memberships-subheader">
              Lists you have joined
            </ListSubheader>
          }
        >
          {pools.map((pool) => (
            <ListItem
              key={pool._id}
              secondaryAction={
                <Button size="small" onClick={() => setConfirming(pool)}>
                  Leave
                </Button>
              }
            >
              <ListItemIcon>
                <GroupsIcon />
              </ListItemIcon>
              <ListItemText
                primary={pool.name}
                secondary={pool.questionGroupName}
              />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Dialog open={!!confirming} onClose={() => setConfirming(null)}>
        <DialogTitle>Leave {confirming?.name}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You will no longer be considered for invitations from this list. You
            can join again at any time from the events page.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirming(null)}>Cancel</Button>
          <Button color="error" disabled={leaving} onClick={handleLeave}>
            {leaving ? "Leaving…" : "Leave"}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PoolMemberships;
